<template>
  <highcharts ref="chart"
              @touchstart.native.stop="stop"
              @touchend.native.stop="stop"
              @drag.native.stop="stop"
              :constructor-type="constructorType"
              :options="options"
              :callback="callback"
              v-if="chartoptions"
              class="fin-chart"/>
</template>

<script>
import "./HighChartInit"
import HighchartsCore from 'highcharts'

export default {
  name: "FinChart2",
  data(){
    return {
      chartoptions: null
    }
  },
  props: {
    /**
     * Determines which constructor highcharts should use.
     * Options: "chart", "stockChart", "mapChart"
     */
    constructorType: {
      type: String,
      default: 'stockChart'
    },

    /**
     * Options for the chart.
     * See: https://api.highcharts.com/highcharts/ or https://api.highcharts.com/highstock/
     */
    options: {
      type: Object
    },

    callback: {
      type: Function
    }
  },
  mounted() {
    setTimeout(  this.reflow, 500)
  },
  watch:{
    '$vuetify.breakpoint.name'(){
      //wait for the breakpoint effects and reflow (next tick is not enough)
      //TODO improve that somehow
      setTimeout(  this.reflow, 500)
      setTimeout(  this.reflow, 1000)
    },
    options:{
      immediate: true,
      handler(val){
        const chart = this.$refs.chart?.chart
        if(chart){
          HighchartsCore.fireEvent(chart, 'beforeChange', {userOptions:val})
        }
        this.chartoptions=val
        this.$nextTick( () => {
          this.reflow() //very important for charts in gridlayouts
          const chart = this.$refs.chart?.chart
          if(chart){
            HighchartsCore.fireEvent(chart, 'afterChange', {userOptions:val})
          }
        })
      }
    }
  },
  computed: {
    chart(){
      return this.$refs.chart?.chart
    }
  },
  methods: {
    stop(){
      //stop bubbling drag/swipe event
      //console.log('just stop')
    },
    reflow(){
      const chart = this.chart
      if(chart){
        chart.reflow()
      }
    }
  },


}
</script>

<style>
.highcharts-tooltip-container {
  z-index: 999999 !important;
}

.creditlink{
  text-decoration: underline;
  cursor: pointer;
}

.credit-nolink{
  cursor: default;
}

</style>
